<template>
    <p class="basic-title-wrap">
        {{ title }}
    </p>
</template>

<script>
export default {
    name: "basicTitle",
    props: {
        // 标题
        title: String,
    }
}
</script>

<style scoped lang="scss">
.basic-title-wrap {
    line-height: 44px;
    font-size: $bigSize;
    color: $deepGreen;
    padding: 0 18px;
    font-weight: 500;
    background: linear-gradient(to right, $deepGreen, $deepGreen) no-repeat center left / 6px 32px;
}
</style>